import { DatabaseFilled, DollarCircleFilled, DownloadOutlined } from '@ant-design/icons'
import { sortByName } from '@components/Reports/TankSupplyDefaults/helpers'
import { Horizontal, Texto } from '@gravitate-js/excalibrr'
import { Select } from 'antd'
import React from 'react'

export function FilterHeader({ setFilters, filters, optionsMetadata }) {
  const { Option } = Select

  return (
    <div className='p-3 bg-3 bordered'>
      <div className='flex justify-sb items-center m-2'>
        <Texto category='heading-small' appearance='secondary'>
          Filter Supply
        </Texto>
        <Horizontal flex={1}>
          <Select
            style={{ width: '100%' }}
            allowClear
            mode='multiple'
            optionFilterProp='children'
            className='ml-4'
            placeholder={
              <Horizontal verticalCenter>
                <DatabaseFilled className='pr-3' /> Terminals
              </Horizontal>
            }
            onChange={(_, row) => setFilters({ ...filters, terminals: row })}
            value={filters?.terminals?.children}
          >
            {optionsMetadata?.terminals?.sort(sortByName).map(({ id, name }) => {
              return <Option key={id}>{name}</Option>
            })}
          </Select>
        </Horizontal>
        <Horizontal flex={1}>
          <Select
            style={{ width: '100%' }}
            allowClear
            mode='multiple'
            className='ml-4'
            optionFilterProp='children'
            placeholder={
              <Horizontal verticalCenter>
                <DownloadOutlined className='pr-3' /> Suppliers
              </Horizontal>
            }
            onChange={(_, row) => setFilters({ ...filters, suppliers: row })}
            value={filters?.suppliers?.children}
          >
            {optionsMetadata?.suppliers?.sort(sortByName).map(({ id, name }) => (
              <Option key={id}>{name}</Option>
            ))}
          </Select>
        </Horizontal>
        <Horizontal flex={1}>
          <Select
            style={{ width: '100%' }}
            allowClear
            mode='multiple'
            className='ml-4'
            placeholder={
              <Horizontal verticalCenter>
                <DollarCircleFilled className='pr-3' /> Price Type
              </Horizontal>
            }
            onChange={(values) => {
              setFilters({ ...filters, price_types: values })
            }}
            value={filters?.price_types}
          >
            {optionsMetadata?.price_types?.map((name) => (
              <Option key={name}>{name}</Option>
            ))}
          </Select>
        </Horizontal>
      </div>
    </div>
  )
}
